import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/40.png'
import _imports_1 from '@/assets/images/100.png'


const _hoisted_1 = { class: "del_notice_out_box" }
const _hoisted_2 = { class: "tt" }
const _hoisted_3 = { class: "desc" }
const _hoisted_4 = { class: "btns_box" }

import { reactive } from 'vue';
import { DelConfrimType } from '@/types/global';


export default /*@__PURE__*/_defineComponent({
  __name: 'DelConfrim',
  setup(__props, { expose: __expose }) {

/**
 * 确认框
 * @example <DelConfrim ref="delConfrim" />
 * 			import DelConfrim from "@/components/DelConfrim.vue"
 * 			import { DelConfrimType } from '@/types/global';
 * 			const delConfrim = ref(null)
 * 			delConfrim.value.show("",()=>{})
 */

const info = reactive({
	isshow: false,
	content: '',
	confirmBakc: () => {
		console.debug('');
	},
	cancelBack: () => {
		console.debug('');
	},

	cancel() {
		info.isshow = false;
		info.cancelBack && info.cancelBack();
	},
	confirm() {
		info.isshow = false;
		info.confirmBakc && info.confirmBakc();
	}
});

function show(content, confirmBakc, cancelBack) {
	info.content = content;
	info.confirmBakc = confirmBakc;
	info.cancelBack = cancelBack;
	info.isshow = true;
}

__expose<DelConfrimType>({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: info.isshow,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((info.isshow) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("提示")), 1),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (info.cancel && info.cancel(...args)))
        }),
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(info.content), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "cancel",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (info.cancel && info.cancel(...args)))
          }, _toDisplayString(_ctx.$t("取消")), 1),
          _createElementVNode("div", {
            class: "confirm",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (info.confirm && info.confirm(...args)))
          }, _toDisplayString(_ctx.$t("确认")), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})